/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteCadresActions, {
    deleteCadreTypes,
} from '../../../redux/cadre/deleteCadre'
import getAllCadresActions from '../../../redux/cadre/getAllCadres'
import { Delete } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* deleteCadreSagas(response) {
    try {
        const responseDelete = yield Delete(
            `cadredirection/${response.response.id}`
        )
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(
                    getAllCadresActions.getAllCadresRequest()
                ),
                yield put(
                    deleteCadresActions.deleteCadreSuccess(
                        responseDelete.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(
                    getAllCadresActions.getAllCadresRequest()
                ),
            ])
        } else {
            yield put(
                deleteCadresActions.deleteCadreFailure(
                    responseDelete.data
                )
            )
        }
    } catch (error) {
        yield put(deleteCadresActions.deleteCadreFailure(error))
    }
}

export function* deleteCadreSaga() {
    yield takeLatest(
        deleteCadreTypes.DELETE_CADRE_REQUEST,
        deleteCadreSagas
    )
}
